import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLoading } from "../../../context/LoadingContext";
import { Card, Container } from "react-bootstrap";
import SearchFilter from "../../../components/SearchFilter";
import Table from "../../../components/Table";
import ConfigureColumnsDisplay from "../../../components/ConfigureColumnsDisplay";

export default function FollowRepairStatus() {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState({ Array: [] });
  const [data, setData] = useState({ Array: [] });
  const [columns, setColumns] = useState({ Array: [] });
  const [tabKeys, setTabKeys] = useState("Array");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const searchInput = [
    {
      name: "from_date",
      label: "จากวันที่",
      type: "Date",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "to_date",
      label: "ถึงวันที่",
      type: "Date",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "technian_name",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "service_req_no",
      label: "เลขที่ใบสั่งงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "job_status",
      label: "สถานะงาน",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "item_name",
      label: "ชนิดอุปกรณ์",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    },
    {
      name: "cus_name",
      label: "ชื่อลูกค้า",
      classNames: { col: "mb-3", label: "mb-1" },
      size: 3
    }
  ];
  const columnOptions = [
    { value: "job_status", label: "สถานะงาน" },
    { value: "item_name", label: "ชนิดอุปกรณ์" },
    { value: "work_order_number", label: "เลขที่ใบสั่งงาน" },
    { value: "repair_doc_date", label: "วันที่แจ้งซ่อม" },
    { value: "cus", label: "ลูกค้า" },
    { value: "service_req_no", label: "หมายเลขแจ้งซ่อม (ลูกค้า)" },
    { value: "customer_mas", label: "รหัสสาขา (ลูกค้า)" },
    { value: "cus_name", label: "ชื่อลูกค้า/สาขา" },
    { value: "serial_No", label: "รายละเอียดอุปกรณ์" },
    { value: "repair_des", label: "อาการที่ได้แจ้งซ่อม" },
    { value: "cus_spec_tex", label: "คำสั่งเพิ่มเติม (ลูกค้า)" },
    { value: "sup_team", label: "ชื่อทีม/หัวหน้าช่าง" },
    { value: "dt_hrs", label: "จำนวนชั่วโมงเข้าทำงานแจ้งซ่อม" },
    { value: "due_date", label: "วัน/เวลา/ครบกำหนด" },
    { value: "work_date", label: "วันเข้างานจริง" },
    { value: "technian_name", label: "ช่างผู้ปฏิบัติงานเข้างาน" }
  ];

  useEffect(() => {
    setColumns((prevCol) => ({
      ...prevCol,
      [tabKeys]: [
        {
          name: "ลำดับ",
          selector: (row) => row.rowIndex,
          sortable: true,
          width: "110px"
        }
      ]
    }));

    const newColumns = columnOptions
      .filter((option) => selectedOptions.includes(option.value))
      .map((option) => ({
        name: option.label,
        selector: (row) => row[option.value]
      }));

    setColumns((prevCol) => ({
      ...prevCol,
      [tabKeys]: [...prevCol[tabKeys], ...newColumns]
    }));
  }, [selectedOptions, tabKeys]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <>
      <Helmet>
        <title>ติดตามสถานะงานแจ้งซ่อม</title>
        <meta name="description" content="Follow Repair Status Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Body>
            <SearchFilter
              data={data.Array}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto py-2" }}
              searchCallback={(search) =>
                setSearchValue((prevState) => ({
                  ...prevState,
                  Array: search
                }))
              }
            />
          </Card.Body>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-end align-items-center border-bottom-0 bg-transparent">
            <ConfigureColumnsDisplay
              options={columnOptions}
              selectedOptions={selectedOptions}
              onSelect={(values) => setSelectedOptions(values)}
            />
          </Card.Header>
          <Table
            data={data.Array}
            column={columns.Array}
            searchFilter={searchValue.Array}
            pending={loading}
            pagination
          />
        </Card>
      </Container>
    </>
  );
}
